/**
 * Internal dependencies.
 */
import edit from './edit';
import save from './save';
import metadata from './block.json';
import { GroupsIcon as icon } from '../../components/Icons';
import styles from './inline-styles';

/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';
import { Icon } from '@wordpress/components';

/**
 * Block constants
 */
const { name, category, attributes, supports } = metadata;

const settings = {
	title: __( 'Team' ),
	description: __( 'Gutenify Team' ),
	icon: <Icon icon={ icon } />,
	keywords: [
		'gutenify',
		__( 'team' ),
	],
	example: {
		attributes: {
			teams: {

			},
		},
	},
	attributes,
	edit,
	save,
	supports,
	gutenify: {
		customStylesCallback( props ) {
			return styles( props );
		},
	},
};

export { name, category, settings };
